export const getBrackgroundColors = key => props => props.theme.v2.colors.background[key];
export const getBorderColors = key => props => props.theme.v2.colors.border[key];
